<template>
  <screen
    class="scan-container"
    :can-skip="false"
    :can-leave="canLeave"
    :screen-info="info"
    :error="hasError"
    @leave="leave"
  >
    <img
      slot="topLeftButton"
      class="force-scan"
      @click="startScanProcess"
      src="../assets/common/start-scan.svg"
      alt="Scan"
    />
    <feet v-if="showFeet" />
    <doll v-show="!showFeet" :status="dollStatus" :completed="scanCompleted" />
    <countdown v-if="countdownTimer > 0" :time="countdownTimer" />
    <scan-progress v-if="scanProgress > -1 && !scanCompleted" :progress="scanProgress" />
  </screen>
</template>

<script>
import audioPlayer from '@/mixins/audio-player';
import autoClearTimer from '@/mixins/auto-clear-timer';
import scanBody from '@/mixins/scan-body';
import { wait } from '@/modules/utils';

import Feet from '@/components/Animations/FeetPos.vue';
import Screen from '@/components/common/Screen.vue';
import Doll from '@/components/ScanBodyWithHandles/Doll.vue';
import Countdown from '@/components/common/Countdown.vue';
import ScanProgress from '@/components/common/ScanProgress.vue';

export default {
  name: 'ScanBodyWithHandles',
  components: {
    Screen,
    Doll,
    Countdown,
    Feet,
    ScanProgress,
  },
  mixins: [audioPlayer, autoClearTimer, scanBody],
  mounted() {
    this.proceed();
  },
  data: () => ({
    dollStatus: 'relaxed',
    canLeave: false,
    showFeet: false,
    scanCompleted: false,
  }),
  methods: {
    async proceed() {
      this.dollStatus = 'relaxed';
      if (this.twoStepScan) {
        this.info = this.$t('scan.two_step_scan');
        await this.playAndWait('two_phase_scan', 1.5);
      }
      // show feet
      this.showFeet = true;
      this.info = this.$t('scan.feet_pos');
      await this.playAndWait('foot_position_feet', 1.5, true);
      this.showFeet = false;
      // hold handles
      this.info = this.$t('handles.hold');
      this.setAutoClearTimer(() => {
        this.dollStatus = 'focusGrip';
      }, 2000);
      await this.playAndWait('hold_handles', 3, true);
      this.info = this.$t('handles.hold_ready');
      await this.playAndWait('scan_about_start', 1.5, true);

      // start scanning
      await this.startScanProcess();
    },
    async proceedStepTwo() {
      this.scanCompleted = false;
      this.resetProgress();
      // letgo
      this.dollStatus = 'focusLetgo';
      this.info = this.$t('handles.letgo_and_keep_feet');
      this.setAutoClearTimer(() => {
        this.dollStatus = 'relaxed';
      }, 2000);
      await this.playAndWait('letgo_handles_look_straight', 3, true);
      // clench
      this.info = this.$t('handles.clench_ipose');
      this.dollStatus = 'fist';
      await this.playAndWait('fist_clenched_arms_straightened', 3, true);
      // ready
      await this.playAndWait('keep_hands_five_apart', 2, true);
      this.info = this.$t('handles.clench_ready');
      await this.playAndWait('scan_about_start', 1.5, true);
      // start scanning
      await this.startScanProcess();
    },
    async startScanProcess() {
      try {
        if (!this.stepTwo) {
          this.dollStatus = 'scanningGrip';
        } else {
          this.dollStatus = 'scanningFist';
        }
        this.info = this.$t('scan.scan_keep_still');
        this.playAudio('12-Keep_body_still', true)
          .then(() => wait(0.5))
          .then(() => this.playAudio('13-Scanning_in_progress', true));
        await this.startScan(true);
        await this.playAudio('14-Scan_complete', true);
        await wait(1);
        await this.finish();
      } catch (e) {
        console.log(`[ERROR] scan failed! ${e.message}`);
        this.$events.alert(this.$t('welcome.unexpected_error'));
        this.leave();
      }
    },
  },
  computed: {
    hasError() {
      return false;
    },
  },
  watch: {
    stepTwo(nv) {
      if (nv) {
        this.proceedStepTwo();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.scan-container {
  ::v-deep {
    .content-container {
      @apply relative justify-center;
    }
  }
}
.force-scan {
  @apply fixed top-0 left-0 mt-10 ml-12 cursor-pointer;
  @screen xs {
    @apply ml-5;
    max-width: 30px;
    margin-top: calc(constant(safe-area-inset-top, -1rem) + 1rem);
    margin-top: calc(env(safe-area-inset-top, -1rem) + 1rem);
  }
}
</style>
